module.exports = __webpack_public_path__ + "static/sport/bgi-form.4849364.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport3/bgi-form.png
// module id = Z0Zo
// module chunks = 0